

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface CountryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface CountryMst {
    id?: number;
    name: string;
    countryCode: string;
    minMobileNumberLength: number;
    maxMobileNumberLength:number;
    minPincodeLength:number;
    maxPincodeLength:number;
    nationality:string;
  parameters?: CountryParameter[];
  links?: any;
  iso?:string;
  currencyPlural?:string;
  taxType?:string;
}

export abstract class CountryData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<CountryMst[]>;
  abstract create(url: string,data: CountryMst): Observable<any>;
  abstract update(url: string,data: CountryMst): Observable<any>;
  abstract delete(url: string): Observable<any>;
}